// DEPRECATED. Do not use this directly
import * as React from 'react';
import { unmountComponentAtNode, unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer } from 'react-dom';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import get from 'lodash/get';
import uid from 'utils/uniqueId';
export default function ({ node, nodeClassName, timeout = 300 }) {
    class Portal extends React.Component {
        constructor(props) {
            super(props);
            this.uid = uid();
            this.createPortal = this.createPortal.bind(this);
            this.renderPortal = this.renderPortal.bind(this);
            this.show = this.show.bind(this);
            this.hide = this.hide.bind(this);
            this.visible = this.visible.bind(this);
            this.renderChildren = this.renderChildren.bind(this);
            this.shouldPortalUpdate = this.shouldPortalUpdate.bind(this);
        }
        componentDidMount() {
            if (!ExecutionEnvironment.canUseDOM)
                return;
            this.renderPortal(this.props, this.isVisible);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            const currentVisible = this.visible(this.props);
            const nextVisible = this.visible(nextProps);
            if (!currentVisible && nextVisible) {
                setTimeout(() => this.renderPortal(nextProps, nextVisible), timeout);
            }
            else if (currentVisible && !nextVisible) {
                this.renderPortal(nextProps, nextVisible);
            }
        }
        shouldComponentUpdate() {
            return false;
        }
        componentWillUnmount() {
            node && unmountComponentAtNode(node);
        }
        show() {
            const showComponentFn = get(this, 'props.showComponent');
            if (typeof showComponentFn === 'function') {
                showComponentFn(this.uid);
            }
        }
        hide() {
            const hideComponentFn = get(this, 'props.hideComponent');
            if (typeof hideComponentFn === 'function') {
                hideComponentFn(this.uid);
            }
        }
        get isVisible() {
            return this.visible(this.props);
        }
        visible(props) {
            return this.uid === props.visibleId;
        }
        createPortal() {
            node = document.createElement('div');
            node.className = nodeClassName;
            document.body.appendChild(node);
        }
        renderPortal(props, active = false) {
            !node && this.createPortal();
            try {
                this.shouldPortalUpdate() && renderSubtreeIntoContainer(this, this.renderChildren(props, active), node);
            }
            catch (e) {
                if (typeof props.onError === 'function')
                    props.onError(e);
            }
        }
        shouldPortalUpdate() {
            return true;
        }
        renderChildren(props, active) {
            if (typeof props === 'undefined' && typeof active === 'undefined') {
                return this.props.children;
            }
            if (process.env.NODE_ENV !== 'production') {
                // tslint:disable-next-line:no-console
                console.warn('Portal.renderChildren called in parent. Override this function if inheriting from this component.');
            }
            return <span />;
        }
        render() {
            return null;
        }
    }
    return Portal;
}
